import request from "@/utils/request";

// 添加二维码
export async function AddQrcode(data) {
  return request({
    url: "/QrCode/AddQrcode",
    method: "post",
    data: data,
  });
}

// 编辑二维码
export async function ModifyChannelQr(data) {
  return request({
    url: "/QrCode/ModifyChannelQr",
    method: "post",
    data: data,
  });
}

// 获取二维码列表
export async function GetChannelQrList(data) {
  return request({
    url: "/QrCode/GetChannelQrList",
    method: "post",
    data: data,
  });
}

// 修改二维码状态
export async function LogoutChannelQrcode(data) {
  return request({
    url: "/QrCode/LogoutChannelQrcode",
    method: "post",
    data: data,
  });
}

// 获取服务技能
export async function QrcodeGenerate() {
  return request({
    url: "/Public/QueryServiceCategoryList",
    method: "post",
  });
}

//获取服务项目
export async function GetServiceItemAllList(data) {
  return request({
    url: "/Public/GetServiceItemAllList",
    method: "get",
    params: data,
  });
}

//获取服务区域
export async function QueryAreaList(data) {
  return request({
    url: "/Public/QueryAreaList",
    method: "post",
    data: data,
  });
}

//获取服务项目详情
export async function QueryServiceItemDetail(data) {
  return request({
    url: "/QrCode/QueryServiceItemDetail",
    method: "post",
    data: data,
  });
}